
import { Options, Prop, Vue } from 'vue-property-decorator'
import Button from 'primevue/button'
import { query } from '@madxnl/mrrabbit'

@Options({
  components: {
    Button,
  },
})
export default class ReceivedPacketMetricsDownloader extends Vue {
  @Prop()
  modelId: string

  loading = false

  getErrorMessage(error: unknown) {
    const graphqlMessage = (error as any)?.response?.errors?.[0]?.message
    if (typeof graphqlMessage === 'string' && graphqlMessage.length > 0) {
      return graphqlMessage
    }
    return error instanceof Error ? error.message : 'Unexpected error'
  }

  async createFile() {
    try {
      this.loading = true
      const result = await query(
        'prepareRecentReceivedPacketsMetricsDownload',
        { variables: { prepareRecentReceivedPacketsMetricsDownload: { bagId: this.modelId } } },
      )

      if (result.prepareRecentReceivedPacketsMetricsDownload != null) {
        this.download(result.prepareRecentReceivedPacketsMetricsDownload)
      }
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Download failed',
        detail: this.getErrorMessage(error),
        life: 3000,
      })
    } finally {
      this.loading = false
    }
  }

  download(ref: string) {
    const link = document.createElement('a')
    link.href = ref
    link.rel = 'noopener'
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
